import { render, staticRenderFns } from "./settlement-import-record.vue?vue&type=template&id=34ec69af&scoped=true&"
import script from "./settlement-import-record.vue?vue&type=script&lang=js&"
export * from "./settlement-import-record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ec69af",
  null
  
)

export default component.exports